import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../pages/AuthContext';
import "../styles/Customer.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBox,
    faPalette,
    faTag,
    faBuilding,
    faCalendarAlt,
    faSave,
    faTimes,
    faCheckCircle,
    faStore,
    faExchangeAlt,
    faExclamationTriangle,
    faLayerGroup,
    faChevronDown,
    faRulerCombined,
    faBoxes,
    faSyncAlt,
    faArrowsLeftRight
} from '@fortawesome/free-solid-svg-icons';

// Create translator instance with Urdu translations
const createFabProductsTranslator = () => {
    let cache = new Map();

    const urduTranslations = {
        addFabProduct: 'فیبرک پروڈکٹ شامل کریں',
        editFabProduct: 'فیبرک پروڈکٹ میں ترمیم کریں',
        fillDetails: 'براہ کرم فیبرک کی تفصیلات درج کریں',
        productName: 'پروڈکٹ کا نام',
        productColorCode: 'رنگ کوڈ',
        batchNumber: 'بیچ نمبر',
        type: 'قسم',
        brand: 'برانڈ',
        totalYards: 'کل یارڈز',
        totalMeters: 'کل میٹرز',
        totalRolls: 'کل رولز',
        stockAlert: 'کم اسٹاک الرٹ',
        date: 'تاریخ',
        addFabProductButton: 'فیبرک پروڈکٹ محفوظ کریں',
        updateFabProduct: 'فیبرک پروڈکٹ اپ ڈیٹ کریں',
        clearButton: 'صاف کریں',
        adding: 'شامل کیا جا رہا ہے...',
        updating: 'اپ ڈیٹ کیا جا رہا ہے...',
        fabProductSaved: 'فیبرک پروڈکٹ کامیابی سے محفوظ ہو گئی!',
        fabProductUpdated: 'فیبرک پروڈکٹ کامیابی سے اپ ڈیٹ ہو گئی!',
        failedAdd: 'فیبرک پروڈکٹ محفوظ کرنے میں ناکامی',
        failedUpdate: 'فیبرک پروڈکٹ اپ ڈیٹ کرنے میں ناکامی',
        networkError: 'نیٹ ورک کی خرابی',
        nameRequired: 'پروڈکٹ کا نام ضروری ہے',
        nameTooShort: 'نام کم از کم 2 حروف کا ہونا چاہیے',
        stockQuantityRequired: 'اسٹاک کی مقدار ضروری ہے',
        alertRequired: 'کم اسٹاک الرٹ ضروری ہے',
        success: 'کامیابی',
        error: 'خرابی',
        warning: 'انتباہ',
        selectShop: 'پہلے دکان منتخب کریں',
        currentShop: 'موجودہ دکان',
        noShopSelected: 'کوئی دکان منتخب نہیں۔ براہ کرم پہلے دکان تبدیل کریں',
        switchShop: 'دکان تبدیل کریں',
        shopSwitched: 'دکان کامیابی سے تبدیل ہو گئی',
        shopSwitchFailed: 'دکان تبدیل کرنے میں ناکامی',
        loadingShops: 'دکانیں لوڈ ہو رہی ہیں...',
        noShops: 'کوئی دکان دستیاب نہیں',
        active: 'فعال',
        current: 'موجودہ',
        selectType: 'قسم منتخب کریں',
        cotton: 'کاٹن',
        silk: 'سلک',
        wool: 'وول',
        linen: 'لینن',
        polyester: 'پولیسٹر',
        blend: 'بلینڈ',
        other: 'دیگر',
        enterProductName: 'پروڈکٹ کا نام درج کریں',
        enterColorCode: 'رنگ کوڈ درج کریں',
        enterBatchNumber: 'بیچ نمبر درج کریں',
        enterBrand: 'برانڈ درج کریں',
        enterStockQuantity: 'اسٹاک کی مقدار درج کریں',
        enterTotalRolls: 'کل رولز درج کریں (اختیاری)',
        enterStockAlert: 'کم اسٹاک الرٹ مقدار درج کریں',
        zeroPlaceholder: '0',
        colorCodeHint: 'پروڈکٹ کا نام لکھیں تو متعلقہ رنگ کوڈز دکھائی دیں گے',
        unitYards: 'یارڈز',
        unitMeters: 'میٹرز',
        selectUnit: 'اسٹاک کی اکائی منتخب کریں',
        autoBatchNo: 'خودکار بیچ نمبر',
        generateBatchNo: 'بیچ نمبر بنائیں',
        stockQuantity: 'اسٹاک کی مقدار',
        yardsToMeters: 'یارڈز → میٹرز',
        metersToYards: 'میٹرز → یارڈز',
        stockInfo: 'اسٹاک کی مقدار کی بنیاد پر یارڈز اور میٹرز خودکار طور پر حساب ہوں گے',
        totalRollsHint: 'اس بیچ میں رولز کی تعداد'
    };

    const loadFromCache = () => {
        try {
            const cached = localStorage.getItem('ourzest_fab_translations');
            if (cached) {
                const parsed = JSON.parse(cached);
                Object.entries(parsed).forEach(([key, value]) => {
                    cache.set(key, value);
                });
            }
        } catch (e) {
            console.log("No cache found");
        }
    };

    const saveToCache = () => {
        try {
            const cacheObj = {};
            cache.forEach((value, key) => {
                cacheObj[key] = value;
            });
            localStorage.setItem('ourzest_fab_translations', JSON.stringify(cacheObj));
        } catch (e) {
            console.error("Error saving to cache:", e);
        }
    };

    const translateAPI = async (text, targetLang) => {
        if (targetLang === 'en') return text;
        if (targetLang === 'ur') {
            for (const [key, value] of Object.entries(urduTranslations)) {
                if (value === text) return value;
            }
            if (urduTranslations[text]) return urduTranslations[text];
        }
        return text;
    };

    const translateText = async (text, targetLang) => {
        const cacheKey = `${text}_${targetLang}`;
        if (cache.has(cacheKey)) return cache.get(cacheKey);
        const translated = await translateAPI(text, targetLang);
        cache.set(cacheKey, translated);
        saveToCache();
        return translated;
    };

    const defaultTexts = {
        addFabProduct: 'Add Fabric Product',
        editFabProduct: 'Edit Fabric Product',
        fillDetails: 'Fill in the fabric product details below',
        productName: 'Product Name',
        productColorCode: 'Color Code',
        batchNumber: 'Batch Number',
        type: 'Type',
        brand: 'Brand',
        totalYards: 'Total Yards',
        totalMeters: 'Total Meters',
        totalRolls: 'Total Rolls',
        stockAlert: 'Low Stock Alert',
        date: 'Date',
        addFabProductButton: 'Save Fabric Product',
        updateFabProduct: 'Update Fabric Product',
        clearButton: 'Clear',
        adding: 'Adding...',
        updating: 'Updating...',
        fabProductSaved: 'Fabric product saved successfully!',
        fabProductUpdated: 'Fabric product updated successfully!',
        failedAdd: 'Failed to save fabric product',
        failedUpdate: 'Failed to update fabric product',
        networkError: 'Network error occurred',
        nameRequired: 'Product name is required',
        nameTooShort: 'Name must be at least 2 characters',
        stockQuantityRequired: 'Stock quantity is required',
        alertRequired: 'Low stock alert quantity is required',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        selectShop: 'Select a shop first',
        currentShop: 'Current Shop',
        noShopSelected: 'No shop selected. Please switch to a shop first.',
        switchShop: 'Switch Shop',
        shopSwitched: 'Shop switched successfully',
        shopSwitchFailed: 'Failed to switch shop',
        loadingShops: 'Loading shops...',
        noShops: 'No shops available',
        active: 'Active',
        current: 'Current',
        selectType: 'Select type',
        cotton: 'Cotton',
        silk: 'Silk',
        wool: 'Wool',
        linen: 'Linen',
        polyester: 'Polyester',
        blend: 'Blend',
        other: 'Other',
        enterProductName: 'Enter product name',
        enterColorCode: 'Enter color code',
        enterBatchNumber: 'Enter batch number',
        enterBrand: 'Enter brand',
        enterStockQuantity: 'Enter stock quantity',
        enterTotalRolls: 'Enter total rolls (optional)',
        enterStockAlert: 'Enter low stock alert quantity',
        zeroPlaceholder: '0',
        colorCodeHint: 'Type product name to see related color codes',
        unitYards: 'Yards',
        unitMeters: 'Meters',
        selectUnit: 'Select stock unit',
        autoBatchNo: 'Auto Batch No',
        generateBatchNo: 'Generate Batch No',
        stockQuantity: 'Stock Quantity',
        yardsToMeters: 'Yards → Meters',
        metersToYards: 'Meters → Yards',
        stockInfo: 'Yards and meters will be calculated automatically based on stock quantity',
        totalRollsHint: 'Number of rolls in this batch'
    };

    const getTranslations = async (lang) => {
        if (lang === 'en') return defaultTexts;
        if (lang === 'ur') return urduTranslations;
        return defaultTexts;
    };

    loadFromCache();
    return { getTranslations, translateText };
};

const fabProductsTranslator = createFabProductsTranslator();

// Toast Notification Component
const ToastNotification = ({ toast, setToast, translations }) => {
    const getIconForType = (type) => {
        if (type === 'success') return faCheckCircle;
        return faExclamationTriangle;
    };

    const getTitleForType = (type) => {
        if (type === 'success') return translations.success || 'Success';
        if (type === 'error') return translations.error || 'Error';
        return translations.warning || 'Warning';
    };

    if (!toast.show) return null;

    return (
        <div className={`toast-notification ${toast.type}`}>
            <div className="toast-content">
                <div className="toast-icon">
                    <FontAwesomeIcon icon={getIconForType(toast.type)} />
                </div>
                <div className="toast-text">
                    <div className="toast-title">{getTitleForType(toast.type)}</div>
                    <div className="toast-message">{toast.message}</div>
                </div>
                <button className="toast-close" onClick={() => setToast(prev => ({ ...prev, show: false }))}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
        </div>
    );
};

// Shop Selector Modal Component
const ShopSelectorModal = ({ isOpen, onClose, shops, currentShop, onSelectShop, translations, loading }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content shop-selector-modal">
                <div className="modal-header">
                    <h3>{translations.switchShop || 'Switch Shop'}</h3>
                    <button className="modal-close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="modal-body">
                    {loading ? (
                        <div className="loading-shops">
                            <div className="loading-spinner-small"></div>
                            <p>{translations.loadingShops || 'Loading shops...'}</p>
                        </div>
                    ) : shops.length === 0 ? (
                        <div className="no-shops">
                            <p>{translations.noShops || 'No shops available'}</p>
                        </div>
                    ) : (
                        <div className="shop-list">
                            {shops.map((shop) => (
                                <div
                                    key={shop.shop_id}
                                    className={`shop-item ${currentShop?.shop_id === shop.shop_id ? 'active' : ''}`}
                                    onClick={() => {
                                        onSelectShop(shop);
                                        onClose();
                                    }}
                                >
                                    <div className="shop-item-icon">
                                        <FontAwesomeIcon icon={faStore} />
                                    </div>
                                    <div className="shop-item-details">
                                        <div className="shop-item-name">{shop.shop_name}</div>
                                        <div className="shop-item-code">{shop.shop_code || `ID: ${shop.shop_id}`}</div>
                                    </div>
                                    {currentShop?.shop_id === shop.shop_id && (
                                        <div className="shop-item-current">
                                            <FontAwesomeIcon icon={faCheckCircle} />
                                            <span>{translations.current || 'Current'}</span>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const AddFabProduct = ({ productId = null, onSuccess = null }) => {
    const { user, currentShop, switchShop, getShopsForSwitch } = useAuth();

    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return user?.language || localStorage.getItem('ourzest_language') || 'en';
    });

    const generateDefaultBatchNo = () => {
        const now = new Date();
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        return `B-${minutes}${seconds}`;
    };

    const [formData, setFormData] = useState({
        date: new Date().toISOString().split('T')[0],
        product_name: '',
        product_colorcode: '',
        batch_no: '',
        type: '',
        brand: '',
        unit: 'yards',
        stock_quantity: '',
        total_rolls: '',
        stock_alert: '',
        themeColor: localStorage.getItem('ourzest_theme') || '#6366f1'
    });

    // Calculated fields
    const [calculatedYards, setCalculatedYards] = useState(0);
    const [calculatedMeters, setCalculatedMeters] = useState(0);

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [translations, setTranslations] = useState({});

    const [availableColorCodes, setAvailableColorCodes] = useState([]);
    const [loadingColorCodes, setLoadingColorCodes] = useState(false);

    const [toast, setToast] = useState({
        show: false,
        type: '',
        message: ''
    });

    const [showShopSelector, setShowShopSelector] = useState(false);
    const [availableShops, setAvailableShops] = useState([]);
    const [loadingShops, setLoadingShops] = useState(false);

    const [showTypeDropdown, setShowTypeDropdown] = useState(false);
    const [typeSearchTerm, setTypeSearchTerm] = useState('');

    const [showBrandDropdown, setShowBrandDropdown] = useState(false);
    const [brandSearchTerm, setBrandSearchTerm] = useState('');

    const isSubmittingRef = useRef(false);
    const submissionLockRef = useRef(false);
    const lastSubmissionRef = useRef(null);
    const toastTimerRef = useRef(null);
    const abortControllerRef = useRef(null);
    const productNameTimeoutRef = useRef(null);
    const batchNoTimeoutRef = useRef(null); // New ref for batch number debounce
    const formRef = useRef(null);

    const typeDropdownRef = useRef(null);
    const brandDropdownRef = useRef(null);

    const typeOptions = [
        { value: '', displayName: 'Select Type' },
        { value: 'cotton', displayName: 'Cotton' },
        { value: 'silk', displayName: 'Silk' },
        { value: 'wool', displayName: 'Wool' },
        { value: 'linen', displayName: 'Linen' },
        { value: 'polyester', displayName: 'Polyester' },
        { value: 'blend', displayName: 'Blend' },
        { value: 'other', displayName: 'Other' }
    ];

    const brandOptions = [
        { value: 'gul_ahmed', displayName: 'Gul Ahmed' },
        { value: 'al_karam', displayName: 'Al Karam' },
        { value: 'sapphire', displayName: 'Sapphire' },
        { value: 'chenone', displayName: 'ChenOne' },
        { value: 'bonanza', displayName: 'Bonanza' }
    ];

    const filteredTypes = typeSearchTerm.trim() === ''
        ? typeOptions
        : typeOptions.filter(type =>
            type.displayName.toLowerCase().includes(typeSearchTerm.toLowerCase())
        );

    const filteredBrands = brandSearchTerm.trim() === ''
        ? brandOptions
        : brandOptions.filter(brand =>
            brand.displayName.toLowerCase().includes(brandSearchTerm.toLowerCase())
        );

    // Auto-calculate yards and meters when stock quantity or unit changes
    useEffect(() => {
        const conversionRate = 0.9144;
        const stockQty = parseFloat(formData.stock_quantity) || 0;

        if (formData.unit === 'yards') {
            setCalculatedYards(stockQty);
            setCalculatedMeters(stockQty * conversionRate);
        } else {
            setCalculatedMeters(stockQty);
            setCalculatedYards(stockQty / conversionRate);
        }
    }, [formData.stock_quantity, formData.unit]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (typeDropdownRef.current && !typeDropdownRef.current.contains(event.target)) {
                setShowTypeDropdown(false);
            }
            if (brandDropdownRef.current && !brandDropdownRef.current.contains(event.target)) {
                setShowBrandDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const showToast = (type, message) => {
        if (toastTimerRef.current) clearInterval(toastTimerRef.current);
        setToast({ show: true, type, message });
        setTimeout(() => setToast(prev => ({ ...prev, show: false })), 3000);
    };

    useEffect(() => {
        return () => {
            if (toastTimerRef.current) clearInterval(toastTimerRef.current);
            if (abortControllerRef.current) abortControllerRef.current.abort();
            if (productNameTimeoutRef.current) clearTimeout(productNameTimeoutRef.current);
            if (batchNoTimeoutRef.current) clearTimeout(batchNoTimeoutRef.current);
            isSubmittingRef.current = false;
            submissionLockRef.current = false;
        };
    }, []);

    useEffect(() => {
        if (user?.language && user.language !== currentLanguage) {
            setCurrentLanguage(user.language);
        }
    }, [user?.language]);

    useEffect(() => {
        const loadTranslations = async () => {
            const trans = await fabProductsTranslator.getTranslations(currentLanguage);
            setTranslations(trans);
        };
        loadTranslations();
    }, [currentLanguage]);

    useEffect(() => {
        if (productId) {
            setIsEditMode(true);
            loadProductData(productId);
        } else {
            // Auto-generate batch number for new product (will be updated when product name changes)
            setFormData(prev => ({ ...prev, batch_no: generateDefaultBatchNo() }));
        }
    }, [productId]);

    useEffect(() => {
        const loadAvailableShops = async () => {
            if (!user) return;
            setLoadingShops(true);
            try {
                const shopsData = await getShopsForSwitch();
                setAvailableShops(shopsData.shops || []);
            } catch (error) {
                console.error('Error loading shops:', error);
                setAvailableShops([]);
            } finally {
                setLoadingShops(false);
            }
        };
        loadAvailableShops();
    }, [user, getShopsForSwitch]);

    // FIXED: Auto-update batch number with debounce - only after user stops typing
    useEffect(() => {
        if (!isEditMode && formData.product_name && formData.product_name.trim().length >= 2) {
            // Clear previous timeout
            if (batchNoTimeoutRef.current) {
                clearTimeout(batchNoTimeoutRef.current);
            }
            // Set new timeout to generate batch number after 1 second of no typing
            batchNoTimeoutRef.current = setTimeout(() => {
                generateAutoBatchNo();
            }, 1000);
        }
        return () => {
            if (batchNoTimeoutRef.current) {
                clearTimeout(batchNoTimeoutRef.current);
            }
        };
    }, [formData.product_name, isEditMode]);

    // FIXED: Fetch color codes with debounce - only after user stops typing
    useEffect(() => {
        if (formData.product_name && formData.product_name.trim().length > 2 && currentShop) {
            if (productNameTimeoutRef.current) clearTimeout(productNameTimeoutRef.current);
            productNameTimeoutRef.current = setTimeout(() => {
                fetchColorCodes(formData.product_name);
            }, 800); // Increased delay to 800ms
        } else {
            setAvailableColorCodes([]);
        }
        return () => {
            if (productNameTimeoutRef.current) clearTimeout(productNameTimeoutRef.current);
        };
    }, [formData.product_name, currentShop]);

    const generateAutoBatchNo = async () => {
        if (!formData.product_name || formData.product_name.trim().length < 2) return;

        // Don't show loading for batch number generation to avoid flickering
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/fab_products.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'generate_batch_no',
                    product_name: formData.product_name
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setFormData(prev => ({ ...prev, batch_no: data.batch_no }));
            }
        } catch (error) {
            console.error('Error generating batch number:', error);
        }
    };

    const fetchColorCodes = async (productName) => {
        if (!currentShop || !productName.trim()) return;
        setLoadingColorCodes(true);
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/fab_products.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_product_colorcodes',
                    product_name: productName,
                    shop_id: currentShop.shop_id
                })
            });
            const data = await response.json();
            if (data.status === 'success') {
                setAvailableColorCodes(data.data || []);
            }
        } catch (error) {
            console.error('Error fetching color codes:', error);
        } finally {
            setLoadingColorCodes(false);
        }
    };

    const selectType = (type) => {
        setFormData(prev => ({ ...prev, type: type.value }));
        setTypeSearchTerm(type.displayName);
        setShowTypeDropdown(false);
    };

    const selectBrand = (brand) => {
        setFormData(prev => ({ ...prev, brand: brand.displayName }));
        setBrandSearchTerm(brand.displayName);
        setShowBrandDropdown(false);
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.product_name?.trim()) {
            newErrors.product_name = translations.nameRequired || 'Product name is required';
        } else if (formData.product_name.trim().length < 2) {
            newErrors.product_name = translations.nameTooShort || 'Name must be at least 2 characters';
        }

        if (!formData.stock_quantity || parseFloat(formData.stock_quantity) <= 0) {
            newErrors.stock_quantity = translations.stockQuantityRequired || 'Stock quantity is required';
        }

        if (formData.stock_alert === '' || parseFloat(formData.stock_alert) < 0) {
            newErrors.stock_alert = translations.alertRequired || 'Low stock alert quantity is required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!currentShop) {
            showToast('error', translations.selectShop || 'Please select a shop first');
            setShowShopSelector(true);
            return;
        }

        if (!validateForm()) return;

        if (isSubmittingRef.current || submissionLockRef.current) {
            showToast('warning', 'Please wait, submission in progress...');
            return;
        }

        const now = Date.now();
        if (lastSubmissionRef.current) {
            const timeDiff = now - lastSubmissionRef.current.time;
            const dataMatch = JSON.stringify(formData) === lastSubmissionRef.current.data;
            if (timeDiff < 3000 && dataMatch) {
                showToast('warning', 'Please wait before submitting again');
                return;
            }
        }

        isSubmittingRef.current = true;
        submissionLockRef.current = true;
        setLoading(true);

        lastSubmissionRef.current = { time: now, data: JSON.stringify(formData) };
        abortControllerRef.current = new AbortController();

        try {
            const currentUsername = user?.username || 'Unknown';
            const stockQuantity = parseFloat(formData.stock_quantity) || 0;

            const productData = {
                action: isEditMode ? 'edit' : 'add',
                date: formData.date,
                product_name: formData.product_name,
                product_colorcode: formData.product_colorcode || null,
                batch_no: formData.batch_no,
                type: formData.type || null,
                brand: formData.brand || null,
                unit: formData.unit,
                stock_quantity: stockQuantity,
                total_rolls: formData.total_rolls ? parseInt(formData.total_rolls) : 0,
                stock_alert: parseFloat(formData.stock_alert) || 0,
                username: currentUsername,
                shop_id: currentShop.shop_id,
                submission_timestamp: now
            };

            if (isEditMode && productId) {
                productData.id = productId;
            }

            const response = await fetch('https://ourzestapp.online/oz_backend/fab_products.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(productData),
                signal: abortControllerRef.current.signal
            });

            const data = await response.json();

            if (data.status === 'success') {
                showToast('success', isEditMode
                    ? (translations.fabProductUpdated || 'Fabric product updated successfully!')
                    : (translations.fabProductSaved || 'Fabric product saved successfully!'));

                if (!isEditMode) {
                    setFormData({
                        date: new Date().toISOString().split('T')[0],
                        product_name: '',
                        product_colorcode: '',
                        batch_no: '',
                        type: '',
                        brand: '',
                        unit: 'yards',
                        stock_quantity: '',
                        total_rolls: '',
                        stock_alert: '',
                        themeColor: formData.themeColor
                    });
                    setTypeSearchTerm('');
                    setBrandSearchTerm('');
                    setCalculatedYards(0);
                    setCalculatedMeters(0);
                    setErrors({});
                }

                if (onSuccess) onSuccess(data.productid || productId);
            } else {
                showToast('error', data.message || (isEditMode ? translations.failedUpdate : translations.failedAdd) || 'Operation failed');
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                showToast('error', error.message || translations.networkError || 'Network error');
            }
        } finally {
            setTimeout(() => {
                isSubmittingRef.current = false;
                submissionLockRef.current = false;
                setLoading(false);
                abortControllerRef.current = null;
            }, 1000);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const handleUnitChange = (unit) => {
        setFormData(prev => ({ ...prev, unit }));
    };

    const handleClear = () => {
        setFormData({
            date: new Date().toISOString().split('T')[0],
            product_name: '',
            product_colorcode: '',
            batch_no: '',
            type: '',
            brand: '',
            unit: 'yards',
            stock_quantity: '',
            total_rolls: '',
            stock_alert: '',
            themeColor: formData.themeColor
        });
        setTypeSearchTerm('');
        setBrandSearchTerm('');
        setCalculatedYards(0);
        setCalculatedMeters(0);
        setErrors({});
        setIsEditMode(false);
        lastSubmissionRef.current = null;
    };

    const handleSwitchShop = async (shop) => {
        try {
            const success = await switchShop(shop.shop_id, shop.shop_name, shop.shop_code);
            showToast(success ? 'success' : 'error',
                success ? (translations.shopSwitched || 'Shop switched successfully')
                    : (translations.shopSwitchFailed || 'Failed to switch shop'));
        } catch (error) {
            showToast('error', translations.shopSwitchFailed || 'Failed to switch shop');
        }
    };

    const loadProductData = async (id) => {
        if (!currentShop) {
            showToast('error', translations.selectShop || 'Please select a shop first');
            setShowShopSelector(true);
            return;
        }

        setLoading(true);
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/fab_products.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_record',
                    id: id,
                    username: user?.username,
                    shop_id: currentShop.shop_id
                })
            });

            const data = await response.json();

            if (data.status === 'success' && data.data) {
                const record = data.data;
                setFormData(prev => ({
                    ...prev,
                    date: record.date || prev.date,
                    product_name: record.product_name || '',
                    product_colorcode: record.product_colorcode || '',
                    batch_no: record.batch_no || '',
                    type: record.type || '',
                    brand: record.brand || '',
                    unit: record.unit || 'yards',
                    stock_quantity: record.unit === 'yards' ? record.total_yards : record.total_meters,
                    total_rolls: record.total_rolls || '',
                    stock_alert: record.stock_alert || '',
                    themeColor: prev.themeColor
                }));

                if (record.type) {
                    const type = typeOptions.find(t => t.value === record.type);
                    if (type) setTypeSearchTerm(type.displayName);
                }
                if (record.brand) setBrandSearchTerm(record.brand);
            } else {
                showToast('error', data.message || 'Failed to load product data');
            }
        } catch (error) {
            showToast('error', translations.networkError || 'Network error');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const applyTheme = (color) => {
            try {
                if (!/^#[0-9A-F]{6}$/i.test(color)) color = '#6366f1';
                const hex = color.replace('#', '');
                const r = parseInt(hex.substring(0, 2), 16);
                const g = parseInt(hex.substring(2, 4), 16);
                const b = parseInt(hex.substring(4, 6), 16);
                const adjust = (amount) => {
                    let newR = Math.max(0, Math.min(255, r + amount));
                    let newG = Math.max(0, Math.min(255, g + amount));
                    let newB = Math.max(0, Math.min(255, b + amount));
                    return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;
                };
                const palette = {
                    'customer-primary-color': color,
                    'customer-primary-dark': adjust(-40),
                    'customer-primary-light': adjust(40),
                    'customer-primary-ultralight': adjust(20),
                    'customer-primary-gradient': `linear-gradient(135deg, ${color}, ${adjust(-20)})`,
                    'customer-primary-shadow': `${color}20`
                };
                Object.entries(palette).forEach(([key, value]) => {
                    document.documentElement.style.setProperty(`--${key}`, value);
                });
            } catch (err) {
                console.error("Error applying theme:", err);
            }
        };
        applyTheme(formData.themeColor);
        const handleThemeChange = () => {
            const theme = localStorage.getItem('ourzest_theme') || '#6366f1';
            if (theme !== formData.themeColor) {
                setFormData(prev => ({ ...prev, themeColor: theme }));
                applyTheme(theme);
            }
        };
        window.addEventListener('storage', handleThemeChange);
        return () => window.removeEventListener('storage', handleThemeChange);
    }, [formData.themeColor]);

    const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar' || currentLanguage === 'ps' || currentLanguage === 'fa';

    const renderShopIndicator = () => {
        if (!currentShop) {
            return (
                <div className="shop-indicator-modern no-shop">
                    <div className="shop-badge">
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                        <span>{translations.noShopSelected || 'No shop selected'}</span>
                    </div>
                    <button className="btn-modern btn-switch-shop" onClick={() => setShowShopSelector(true)} type="button">
                        <FontAwesomeIcon icon={faExchangeAlt} />
                        <span>{translations.switchShop || 'Switch Shop'}</span>
                    </button>
                </div>
            );
        }
        return null;
    };

    return (
        <div className={`customer-form-independent ${isRTL ? 'rtl' : ''}`}>
            <ToastNotification toast={toast} setToast={setToast} translations={translations} />

            <ShopSelectorModal
                isOpen={showShopSelector}
                onClose={() => setShowShopSelector(false)}
                shops={availableShops}
                currentShop={currentShop}
                onSelectShop={handleSwitchShop}
                translations={translations}
                loading={loadingShops}
            />

            <div className="form-header-modern">
                <div className="header-content">
                    <div className="header-icon">
                        <FontAwesomeIcon icon={faBox} />
                    </div>
                    <div className="header-text">
                        <h1>{isEditMode ? translations.editFabProduct : translations.addFabProduct}</h1>
                        <p>{translations.fillDetails}</p>
                    </div>
                </div>
                {renderShopIndicator()}
            </div>

            <form ref={formRef} onSubmit={handleSubmit} className="modern-form">
                <div className="form-grid-modern">
                    {/* Date Field */}
                    <div className={`form-group-modern ${errors.date ? 'has-error' : ''}`}>
                        <div className="input-container">
                            <FontAwesomeIcon icon={faCalendarAlt} className="input-icon" />
                            <input
                                type="date"
                                name="date"
                                value={formData.date}
                                onChange={handleChange}
                                disabled={loading}
                                className="no-rtl"
                            />
                            <label className="input-label">{translations.date}</label>
                        </div>
                        {errors.date && <div className="error-message-modern">{errors.date}</div>}
                    </div>

                    {/* Product Name */}
                    <div className={`form-group-modern ${errors.product_name ? 'has-error' : ''}`}>
                        <div className="input-container">
                            <FontAwesomeIcon icon={faBox} className="input-icon" />
                            <input
                                type="text"
                                name="product_name"
                                value={formData.product_name}
                                onChange={handleChange}
                                required
                                placeholder={translations.enterProductName || 'Enter product name'}
                                disabled={loading || isSubmittingRef.current}
                                dir={isRTL ? 'rtl' : 'ltr'}
                            />
                            <label className="input-label">
                                {translations.productName || 'Product Name'}
                                <span className="required">*</span>
                            </label>
                        </div>
                        {errors.product_name && <div className="error-message-modern">{errors.product_name}</div>}
                        
                    </div>

                    {/* Product Color Code with Datalist */}
                    <div className={`form-group-modern ${errors.product_colorcode ? 'has-error' : ''}`}>
                        <div className="input-container">
                            <FontAwesomeIcon icon={faPalette} className="input-icon" />
                            <input
                                type="text"
                                name="product_colorcode"
                                value={formData.product_colorcode}
                                onChange={handleChange}
                                placeholder={translations.enterColorCode || 'Enter color code'}
                                disabled={loading || isSubmittingRef.current}
                                dir={isRTL ? 'rtl' : 'ltr'}
                                list="colorCodesList"
                                autoComplete="off"
                            />
                            <datalist id="colorCodesList">
                                {availableColorCodes.map((code, index) => (
                                    <option key={index} value={code} />
                                ))}
                            </datalist>
                            <label className="input-label">
                                {translations.productColorCode || 'Color Code'}
                            </label>
                        </div>
                        {errors.product_colorcode && <div className="error-message-modern">{errors.product_colorcode}</div>}
                    </div>

                    {/* Batch Number */}
                    <div className={`form-group-modern ${errors.batch_no ? 'has-error' : ''}`}>
                        <div className="input-container">
                            <FontAwesomeIcon icon={faTag} className="input-icon" />
                            <input
                                type="text"
                                name="batch_no"
                                value={formData.batch_no}
                                onChange={handleChange}
                                placeholder={translations.enterBatchNumber || 'Enter batch number'}
                                disabled={loading}
                                dir={isRTL ? 'rtl' : 'ltr'}
                            />
                            <label className="input-label">
                                {translations.batchNumber}
                                <span className="optional">({translations.autoBatchNo})</span>
                            </label>
                        </div>
                        {/* Removed the auto-generate button to prevent confusion, batch number generates automatically after typing stops */}
                    </div>

                    {/* Type Field (replaces Category) */}
                    <div className="form-group-modern" ref={typeDropdownRef}>
                        <div className="input-container">
                            <FontAwesomeIcon icon={faLayerGroup} className="input-icon" />
                            <input
                                type="text"
                                id="type_search"
                                value={typeSearchTerm}
                                onChange={(e) => {
                                    setTypeSearchTerm(e.target.value);
                                    setShowTypeDropdown(true);
                                    if (!typeOptions.find(t => t.displayName.toLowerCase() === e.target.value.toLowerCase())) {
                                        setFormData(prev => ({ ...prev, type: '' }));
                                    }
                                }}
                                onFocus={() => setShowTypeDropdown(true)}
                                placeholder={translations.selectType || 'Select type'}
                                disabled={loading || isSubmittingRef.current}
                                dir={isRTL ? 'rtl' : 'ltr'}
                                autoComplete="off"
                            />
                            <label htmlFor="type_search" className="input-label">
                                {translations.type || 'Type'}
                                <span className="optional">(Optional)</span>
                            </label>
                            <FontAwesomeIcon icon={faChevronDown} className="dropdown-icon" />
                        </div>

                        {showTypeDropdown && (
                            <div className="category-dropdown">
                                {filteredTypes.length > 0 ? (
                                    filteredTypes.map(type => (
                                        <div
                                            key={type.value}
                                            className={`category-option ${formData.type === type.value ? 'selected' : ''}`}
                                            onClick={() => selectType(type)}
                                        >
                                            <div className="category-name">
                                                {translations[type.value] || type.displayName}
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="category-dropdown empty">
                                        <FontAwesomeIcon icon={faExclamationTriangle} />
                                        No types found
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Brand Field (replaces Company) */}
                    <div className="form-group-modern" ref={brandDropdownRef}>
                        <div className="input-container">
                            <FontAwesomeIcon icon={faBuilding} className="input-icon" />
                            <input
                                type="text"
                                id="brand_search"
                                value={brandSearchTerm}
                                onChange={(e) => {
                                    setBrandSearchTerm(e.target.value);
                                    setShowBrandDropdown(true);
                                    setFormData(prev => ({ ...prev, brand: e.target.value }));
                                }}
                                onFocus={() => setShowBrandDropdown(true)}
                                placeholder={translations.enterBrand || 'Enter or select brand'}
                                disabled={loading || isSubmittingRef.current}
                                dir={isRTL ? 'rtl' : 'ltr'}
                                autoComplete="off"
                            />
                            <label htmlFor="brand_search" className="input-label">
                                {translations.brand || 'Brand'}
                                <span className="optional">(Optional)</span>
                            </label>
                            <FontAwesomeIcon icon={faChevronDown} className="dropdown-icon" />
                        </div>

                        {showBrandDropdown && (
                            <div className="category-dropdown">
                                {filteredBrands.length > 0 ? (
                                    filteredBrands.map(brand => (
                                        <div
                                            key={brand.value}
                                            className={`category-option ${formData.brand === brand.displayName ? 'selected' : ''}`}
                                            onClick={() => selectBrand(brand)}
                                        >
                                            <div className="category-name">{brand.displayName}</div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="category-dropdown empty">
                                        <FontAwesomeIcon icon={faExclamationTriangle} />
                                        No brands found
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Unit Selection Toggle */}
                    <div className="form-group-modern">
                        <div className="unit-toggle-container">
                            <button
                                type="button"
                                className={`unit-toggle-btn ${formData.unit === 'yards' ? 'active' : ''}`}
                                onClick={() => handleUnitChange('yards')}
                                aria-label="Switch to Yards"
                                title="Use Yards as stock unit"
                            >
                                <FontAwesomeIcon icon={faRulerCombined} />
                                <span>{translations.unitYards || 'Yards'}</span>
                            </button>
                            <button
                                type="button"
                                className={`unit-toggle-btn ${formData.unit === 'meters' ? 'active' : ''}`}
                                onClick={() => handleUnitChange('meters')}
                                aria-label="Switch to Meters"
                                title="Use Meters as stock unit"
                            >
                                <FontAwesomeIcon icon={faArrowsLeftRight} />
                                <span>{translations.unitMeters || 'Meters'}</span>
                            </button>
                        </div>
                    </div>

                    {/* Stock Quantity */}
                    <div className={`form-group-modern ${errors.stock_quantity ? 'has-error' : ''}`}>
                        <div className="input-container">
                            <FontAwesomeIcon icon={faBoxes} className="input-icon" />
                            <input
                                type="number"
                                name="stock_quantity"
                                value={formData.stock_quantity}
                                onChange={handleChange}
                                required
                                step="0.01"
                                min="0"
                                placeholder={translations.enterStockQuantity || 'Enter stock quantity'}
                                disabled={loading}
                                className="no-rtl"
                            />
                            <label className="input-label">
                                {translations.stockQuantity || 'Stock Quantity'} ({formData.unit === 'yards' ? (translations.unitYards || 'Yards') : (translations.unitMeters || 'Meters')})
                                <span className="required">*</span>
                            </label>
                        </div>
                        {errors.stock_quantity && <div className="error-message-modern">{errors.stock_quantity}</div>}
                    </div>

                    {/* Total Rolls Field - Added after Stock Quantity */}
                    <div className="form-group-modern">
                        <div className="input-container">
                            <FontAwesomeIcon icon={faBoxes} className="input-icon" />
                            <input
                                type="number"
                                name="total_rolls"
                                value={formData.total_rolls}
                                onChange={handleChange}
                                step="1"
                                min="0"
                                placeholder={translations.enterTotalRolls || 'Enter total rolls (optional)'}
                                disabled={loading}
                                className="no-rtl"
                            />
                            <label className="input-label">
                                {translations.totalRolls || 'Total Rolls'}
                                <span className="optional">(Optional)</span>
                            </label>
                        </div>
                    </div>

                    {/* Calculated Yards Display */}
                    <div className="form-group-modern readonly-field">
                        <div className="input-container">
                            <FontAwesomeIcon icon={faRulerCombined} className="input-icon" />
                            <input
                                type="text"
                                value={calculatedYards.toFixed(2)}
                                readOnly
                                className="readonly-input no-rtl"
                            />
                            <label className="input-label">
                                {translations.totalYards || 'Total Yards'}
                                {formData.unit === 'yards' && <span className="stock-badge">Primary Unit</span>}
                                {formData.unit === 'meters' && <span className="conversion-badge">Converted</span>}
                            </label>
                        </div>
                    </div>

                    {/* Calculated Meters Display */}
                    <div className="form-group-modern readonly-field">
                        <div className="input-container">
                            <FontAwesomeIcon icon={faArrowsLeftRight} className="input-icon" />
                            <input
                                type="text"
                                value={calculatedMeters.toFixed(2)}
                                readOnly
                                className="readonly-input no-rtl"
                            />
                            <label className="input-label">
                                {translations.totalMeters || 'Total Meters'}
                                {formData.unit === 'meters' && <span className="stock-badge">Primary Unit</span>}
                                {formData.unit === 'yards' && <span className="conversion-badge">Converted</span>}
                            </label>
                        </div>
                    </div>

                    {/* Stock Alert */}
                    <div className={`form-group-modern ${errors.stock_alert ? 'has-error' : ''}`}>
                        <div className="input-container">
                            <FontAwesomeIcon icon={faExclamationTriangle} className="input-icon" />
                            <input
                                type="number"
                                name="stock_alert"
                                value={formData.stock_alert}
                                onChange={handleChange}
                                required
                                step="1"
                                min="0"
                                placeholder={translations.enterStockAlert || 'Enter low stock alert quantity'}
                                disabled={loading}
                                className="no-rtl"
                            />
                            <label className="input-label">
                                {translations.stockAlert} <span className="required">*</span>
                            </label>
                        </div>
                        {errors.stock_alert && <div className="error-message-modern">{errors.stock_alert}</div>}
                    </div>
                </div>

                {/* Form Actions */}
                <div className="form-actions-modern">
                    <button type="button" className="btn-modern btn-secondary-modern" onClick={handleClear} disabled={loading}>
                        <FontAwesomeIcon icon={faTimes} />
                        <span>{translations.clearButton}</span>
                    </button>
                    <button type="submit" className="btn-modern btn-primary-modern" disabled={loading || !currentShop || isSubmittingRef.current}>
                        {loading || isSubmittingRef.current ? (
                            <>
                                <div className="btn-spinner"></div>
                                <span>{isEditMode ? translations.updating : translations.adding}</span>
                            </>
                        ) : (
                            <>
                                <span>{isEditMode ? translations.updateFabProduct : translations.addFabProductButton}</span>
                                <FontAwesomeIcon icon={faSave} />
                            </>
                        )}
                    </button>
                </div>
            </form>

            {/* Loading Overlay */}
            {loading && (
                <div className="loading-overlay">
                    <div className="loading-content">
                        <div className="loading-spinner"></div>
                        <p>{translations.adding || 'Adding...'}</p>
                        <p className="loading-subtext">Please wait while we add fabric product data</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddFabProduct;